import { IUser } from '@wix/yoshi-flow-editor';
import { UserData } from '../types/common';

export function getUserData(user: IUser): UserData {
  const { id, instance, role, loggedIn } = user;
  return { id, instance, role, loggedIn };
}
